export const SHIPPING_TYPES = {
  EBAY_GLOBAL_SHIPPING: true,
  INTERNATIONAL_SHIPPING: false,
};

export const POLICY_TYPES = {
  shipping: 'shippingPolicyCode',
  payment: 'paymentPolicyCode',
  returns: 'returnsPolicyCode',
};

export const POLICY_KEYS_TYPES = {
  SHIPPING: 'shipping',
  PAYMENT: 'payment',
  RETURNS: 'returns',
};
